import React, { useEffect } from 'react';
import { ButtonVariant } from '@vimily/bonjoro-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import EmptyResponse from '~/App/Modules/MyLibrary/Components/EmptyResponse';
import InfiniteMediaLibrary, {
  GridTileType,
} from '~/App/Modules/MyLibrary/Components/InfiniteMediaLibrary';
import { InfiniteMediaItemConfigProps } from '~/App/Modules/MyLibrary/Context/infinite-media-item-config-context';
import Empty from '~/App/Modules/MyLibrary/Components/Empty';
import CollectResponsesButton from '~/App/Modules/MyLibrary/Components/CollectResponsesButton';
import { usePublishSelectModalContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishSelectModalContext';
import { AssetPageProps } from './AllDisplay';
import { PaginationMetadata, UsePagination } from '~/react-hooks/usePagination';
import { MediaLibraryAsset } from '~/App/Modules/MyLibrary/Components/InfiniteMediaLibraryItem';
import { usePublishPageContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishPageContext';

const ResponsesDisplay = ({
  perPage = 16,
  scrollContainerRef,
  isItemSelectDisabled,
}: AssetPageProps) => {
  const publishSelectModalContext = usePublishSelectModalContext();

  if (!publishSelectModalContext) {
    return <></>;
  }

  const {
    testimonialsPagination,
    selectedTestimonialsPagination,
    invalidateTestimonialRespondentQueries,
    setPerPage,
    addSelectedId,
    removeSelectedId,
    selectedIds,
    filteredTags,
    getFilteredTagCollection,
    clearSelectedTags,
  } = publishSelectModalContext;

  const publishContext = usePublishPageContext();

  const savedSelectedIds = publishContext?.publish?.publishable_resources || [];

  useEffect(() => {
    setPerPage(perPage);
  }, [perPage]);

  const hasTestimonials =
    !!testimonialsPagination?.[2].total ||
    !!selectedTestimonialsPagination?.[2].total;
  const isLoading =
    testimonialsPagination?.[2].loading ||
    selectedTestimonialsPagination?.[2].loading;

  if (
    Object.keys(filteredTags).length === 0 &&
    !isLoading &&
    !hasTestimonials
  ) {
    return (
      <Empty
        title="You haven't received any responses yet"
        subtitle='Easily request video or written testimonials from your customers.'
        cta={
          <CollectResponsesButton
            text='Create new request'
            variant={ButtonVariant.Primary}
            icon={<FontAwesomeIcon className='text-lg' icon={faPlus} />}
            className='rounded-none flex text-center px-4 gap-x-2 text-base items-center'
          />
        }
        image={
          <img
            src='https://cdn.bonjoro.com/assets/images/tm-lp.jpg'
            width={646}
            height={322}
          />
        }
      />
    );
  }

  const makePaginationData = () => {
    const data: UsePagination<MediaLibraryAsset, PaginationMetadata>[] = [];

    if (savedSelectedIds.length && selectedTestimonialsPagination) {
      data.push(selectedTestimonialsPagination);
    }

    if (testimonialsPagination) {
      data.push(testimonialsPagination);
    }

    return data;
  };

  return (
    <>
      <InfiniteMediaLibrary
        perPage={perPage}
        paginationData={makePaginationData()}
        onTagUpdated={invalidateTestimonialRespondentQueries}
        orderByCreatedAt={false}
        emptyComponent={
          <EmptyResponse
            tags={getFilteredTagCollection()}
            clearTags={clearSelectedTags}
          />
        }
        scrollContainerRef={scrollContainerRef}
        gridTileType={GridTileType.Dynamic}
        itemConfig={
          {
            hideInteractionStats: true,
            selectMode: true,
          } as InfiniteMediaItemConfigProps
        }
        addSelectedId={addSelectedId}
        removeSelectedId={removeSelectedId}
        selectedIds={selectedIds}
        isItemSelectDisabled={isItemSelectDisabled}
      />
    </>
  );
};

export default ResponsesDisplay;
